import { guideList } from "@/mocks/chigua";

export default function Guide() {
  return (
    <section id="guide" className="py-16 md:py-20">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-8">
        <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-2">
          <div>
            <p className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-3 py-1 text-sm font-semibold text-accent-800">
              <i className="ri-book-open-fill" aria-hidden="true"></i> 吃瓜不迷路
            </p>
            <h2 className="mt-3 font-display text-3xl text-foreground-900 md:text-4xl">吃瓜指南</h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
              吃瓜也要讲方法。面对铺天盖地的现场信息,懂得如何快速梳理、理性判断,
              才能既吃到瓜的乐趣,又不被带节奏。这份指南,送给每一位前排围观群众。
            </p>

            <ol className="mt-8 space-y-4">
              {[
                { step: "1", text: "先看爆炸瓜的实时热榜,锁定当前最受关注的现场" },
                { step: "2", text: "点进现场,按时间线梳理前因后果,分清事实与猜测" },
                { step: "3", text: "参考多方回应与评论区,理性判断后再参与讨论" },
              ].map((s) => (
                <li key={s.step} className="flex items-start gap-4">
                  <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-primary-500 font-display text-lg text-white">
                    {s.step}
                  </span>
                  <p className="pt-2 text-sm font-medium text-foreground-700 md:text-base">
                    {s.text}
                  </p>
                </li>
              ))}
            </ol>
          </div>

          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
            {guideList.map((g) => (
              <div
                key={g.title}
                className="rounded-2xl border border-secondary-200 bg-background-50 p-6 transition hover:border-primary-300 hover:bg-white"
              >
                <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-accent-100 text-2xl text-accent-700">
                  <i className={g.icon} aria-hidden="true"></i>
                </span>
                <h3 className="mt-4 text-base font-bold text-foreground-900">{g.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{g.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}